export default __webpack_public_path__ + "static/media/Group941.d67e4976.svg";